import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class CheckBox extends React.Component {
  render () {
    const classes = Object.assign({}, { "form-group": true }, this.props.extraHtmlClasses);
    return (
      <div className={classNames(classes)}>
        <h4 onClick={ () => this.input.click() }>{this.props.title}</h4>
        <input
          style={{ width: "30px", height: "30px" }}
          type="checkbox"
          value={this.props.value}
          checked={this.props.checked}
          ref={(input) => this.input = input }
          name="not-used"
          onClick={this.props.onClick}
        />
      </div>
    );
  }
}

CheckBox.propTypes = {
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  extraHtmlClasses: PropTypes.object.isRequired
};

export default CheckBox;
